import { useEffect, useRef } from "react";
import InfoPersoStep4Bloc from "../blocs/info-perso/InfoPersoStep4Bloc";
import { isMobile, scroll2Top } from "../utils/utils";
import GeneralDataProtectionBloc from "../blocs/common/GeneralDataProtectionBloc";

export default function InfoPersoStep4Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
     
      <div className="entreprise-container">
        <h1 className="title ml-lg-desktop mb-sm">Accélérez vos remboursements&nbsp;: joignez votre RIB</h1>
        <p className="text ml-lg-desktop mt-sm" style={{textAlign: 'justify'}}>
          Pour accélérer le remboursement de vos frais de santé, nous vous invitons à renseigner vos coordonnées bancaires.
        </p>
        <p className="text ml-lg-desktop" style={{textAlign: 'justify'}}>
          Si vous souscrivez des options ou ajoutez des ayants droit par la suite, ce compte servira au paiement de vos cotisations.
        </p>
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop">
            <InfoPersoStep4Bloc/>
        </div>
          <GeneralDataProtectionBloc/>
      </div>
   
    )

}